export default "__VITE_ASSET__D53p8QGw__"